import { useQuery } from '@tanstack/react-query';
import { stringify as toQueryString } from '@AppModels/QueryStringUtils';
import { IOperationResultNoValue } from '../../surveys/models/Api';
import { useApiClientContext } from '../../surveys/context';

export interface ISecureSendAttachment {
	id: string;
	fileName: string;
	fileSize: number;
	downloads: number;
	_type: 'SharedAttachmentMetadata';
}

export interface ISecureSendCreator {
	firstName?: string;
	lastName?: string;
}

export interface ISecureSendResponse {
	id: string;
	title?: string;
	/** What the sender wrote about the files, shown under the title. */
	description?: string;
	contactId: string;
	fileAttachments: ISecureSendAttachment[];
	expiration: string;
	shortLink: string;
	notifyOnDownload: boolean;
	creator?: ISecureSendCreator;
	creationDate: string;
	lastModifiedDate: string;
	_type: 'SharedFileLink';
}

export const SECURE_SEND_BY_TOKEN_QUERY_KEY = 'SecureSend/byToken';

export const useClientGetSecureSendByToken = ({
	token,
	enabled = true,
	retry,
}: {
	token: string;
	enabled?: boolean;
	retry?: boolean | number | ((failureCount: number, error: IOperationResultNoValue) => boolean);
}) => {
	const { apiClient } = useApiClientContext();

	return useQuery({
		enabled: enabled && !!token,
		queryFn: () => apiClient.get<ISecureSendResponse>(`sharedFileLink/byToken?${toQueryString({ token })}`),
		queryKey: [SECURE_SEND_BY_TOKEN_QUERY_KEY, token],
		refetchOnWindowFocus: false,
		retry,
	});
};
